import React, { useState, useEffect } from "react";
import axios from "../../util/axiosInstance";
import { CalendarRange, Calendar1, File, CalendarDays } from "lucide-react";
import { useLocation } from "react-router-dom";
import MonthlyReports from "./MonthlyReports.tsx";
import WeeklyReports from "./WeeklyReports.tsx";
import DailyReports from "./DailyReports.tsx";
import ReportGroups from "./ReportGroups.tsx";

type Unit = {
  id: string;
  name: string;
};

export const MainReport: React.FC = ({}) => {
  const location = useLocation();

  // Read filter state from navigation
  const filterState = location.state || {};
  const {
    deviceIds = [],
    filterApplied = false,
    name: filterName,
    type: filterType,
  } = filterState;
  const [currentTab, setCurrentTab] = useState<
    "monthly-reports" | "weekly-reports" | "daily-reports" | "report-groups"
  >("monthly-reports");

  const [loading, setLoading] = useState(true);
  const [units, setUnits] = useState<Unit[]>([]);
  const previewGroupId = sessionStorage.getItem("previewGroupId");
  const fetchUnits = async () => {
    try {
      setLoading(true);

      const response = await axios.get(
        `${process.env.REACT_APP_API_GATEAWAY}/devices?groupId=${previewGroupId}`
      );

      const data = response.data || [];

      let processedUnits: Unit[] = data.map((unit: any) => ({
        id: unit.id,
        name: unit.name,
      }));

      if (filterApplied && deviceIds.length > 0) {
        processedUnits = processedUnits.filter((u) => deviceIds.includes(u.id));
      }
      console.log("Fetched units:", processedUnits);
      setUnits(processedUnits);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching devices:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUnits();
  }, []);
  return (
    <div className="h-full">
      {/* Tabs */}
      <div className="flex gap-2 justify-end mb-2">
        {[
          {
            key: "monthly-reports",
            label: "Monthly Reports",
            icon: CalendarDays,
          },
          {
            key: "weekly-reports",
            label: "Weekly Reports",
            icon: CalendarRange,
          },
          {
            key: "daily-reports",
            label: "Daily Reports",
            icon: Calendar1,
          },
          // { key: "report-groups", label: "Report Groups", icon: File },
        ].map((tab) => (
          <button
            key={tab.key}
            className={`px-3 py-1 text-white text-sm ${
              currentTab === tab.key
                ? "bg-blue-500"
                : "bg-gray-700 hover:bg-gray-600"
            }`}
            onClick={() => setCurrentTab(tab.key as any)}
          >
            <tab.icon className="inline-block w-4 h-4 mr-1" />
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab content */}
      <div className="mt-2">
        {currentTab === "monthly-reports" && (
          <MonthlyReports units={units} loadingUnitSearchData={loading} />
        )}
        {currentTab === "weekly-reports" && (
          <WeeklyReports units={units} loadingUnitSearchData={loading} />
        )}
        {currentTab === "daily-reports" && (
          <DailyReports units={units} loadingUnitSearchData={loading} />
        )}
        {currentTab === "report-groups" && <ReportGroups />}
      </div>
    </div>
  );
};
